<template>
  <section>
    <b-tabs>
      <b-tab :title="$t('ACCESS')" active @click="cancelAdd">
        <b-form inline class="mt-2">
          <b-form-input trim
            v-model="searchText"
            :placeholder="$t('SEARCH')"
            @keydown.enter.prevent
            class="searchText newline-mobile ml-0"
          ></b-form-input>
        </b-form>

        <b-table
          small
          class="mt-2"
          :busy="loading"
          bordered
          :items="currentItems"
          hover
          :fields="fields"
          @row-clicked="clickedRow"
        >
          <template #head(name)>
            <b-form-checkbox
              v-if="currentItems.length != 0"
              v-model="remove_all"
              @change="removeAll"
            ></b-form-checkbox>
            {{ $t("NAME") }}
          </template>

          <template #head(id)>
            <b-form-checkbox
              v-if="currentItems.length != 0"
              v-model="remove_all"
              @change="removeAll"
            ></b-form-checkbox>
            &nbsp;
          </template>

          <template v-slot:cell(name)="data">
            <b-form inline>
              <b-form-checkbox :disabled="disableCheck(data.item)"                
                v-model="RemoveFunctionBoxAccountDTO.user_uuids"
                :value="data.item.user_uuid"
              ></b-form-checkbox>
              <b-img
                class="profileImage"
                src="/img/default-avatar.png"
                alt="placeholder"
                rounded="circle"
              ></b-img>
              {{ data.item.name }}
            </b-form>
          </template>

          <template v-slot:cell(email)="data">{{ data.item.email }}</template>

          <template v-slot:cell(is_admin)="data">{{
            showAdmin(data.item.is_admin)
          }}</template>

          
          <template v-slot:cell(new_message_notification)="data">{{
            data.item.new_message_notification ? $t("YES") : $t("NO")
          }}</template>

          <template v-slot:cell(id)="data">
            <b-form inline>
              <b-form-checkbox :disabled="disableCheck(data.item)"
                v-model="RemoveFunctionBoxAccountDTO.user_uuids"
                :value="data.item.user_uuid"
              ></b-form-checkbox>

              <UserInfo
                image="/img/default-avatar.png"
                :primary="data.item.name"
                :secondary="data.item.email"
              ></UserInfo>
            </b-form>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
        </b-table>

        <b-pagination
          class="mt-2"
          v-model="currentPage"
          :total-rows="totalCurrentItems"
          :per-page="limit"
          align="center"
          pills
          @input="getCurrentUsers"
        >
        </b-pagination>

        <hr class="p-0 m-0 mt-2 mb-2" />

        <b-button
          :disabled="!validRemove"
          variant="danger"
          class="btn-fill"
          @click="removeBtn"
          >{{ $t("REMOVE") }}</b-button
        >
      </b-tab>

      <b-tab :title="$t('ADD')" @click="showAddBtn">
        <b-form inline class="mt-2">
          <b-form-input trim
            v-model="searchText"
            :placeholder="$t('SEARCH')"
            @keydown.enter.prevent
            class="searchText newline-mobile ml-0"
          ></b-form-input>
        </b-form>

        <b-table
          small
          class="mt-2"
          :busy="loading"
          bordered
          :items="items"
          :fields="fields_add"
          @row-clicked="clickedRow"
        >
          <template #head(name)>
            <b-form-checkbox
              v-if="items.length != 0"
              v-model="add_all"
              @change="addAll"
            ></b-form-checkbox>
            {{ $t("NAME") }}
          </template>

          <template #head(id)>
            <b-form-checkbox
              v-if="items.length != 0"
              v-model="add_all"
              @change="addAll"
            ></b-form-checkbox>
            &nbsp;
          </template>

          <template v-slot:cell(name)="data">
            <b-form inline>
              <b-form-checkbox
                v-model="AddFunctionBoxAccountDTO.user_uuids"
                :value="data.item.user_uuid"
              ></b-form-checkbox>
              <b-img
                class="profileImage"
                src="/img/default-avatar.png"
                alt="placeholder"
                rounded="circle"
              ></b-img>
              {{ data.item.name }}
            </b-form>
          </template>

          <template v-slot:cell(email)="data">{{ data.item.email }}</template>


          <template v-slot:cell(id)="data">
            <b-form inline>
              <b-form-checkbox
                v-model="AddFunctionBoxAccountDTO.user_uuids"
                :value="data.item.user_uuid"
              ></b-form-checkbox>

              <UserInfo
                image="/img/default-avatar.png"
                :primary="data.item.name"
                :secondary="data.item.email"
              ></UserInfo>
            </b-form>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
        </b-table>

        <b-pagination
          class="mt-2"
          v-model="usersPage"
          :total-rows="totalItems"
          :per-page="limit"
          align="center"
          pills
          @input="getUsers"
        >
        </b-pagination>

        <hr class="p-0 m-0 mt-2 mb-2" />

        <b-button
          :disabled="!valid"
          variant="primary"
          class="btn-fill"
          @click="addBtn"
          >{{ $t("ADD") }}</b-button
        >
      </b-tab>
    </b-tabs>

    <b-modal
      id="add-functionbox-users-settings"
      v-model="functionBoxUserSettings"
      hide-header
      @cancel="cancelSave"
      :dialog-class="teams.theme"
      @ok="okSave"
      centered
      :cancel-title="$t('CANCEL')"
      :ok-title="$t('ADD')"
    >
      <b-form-checkbox
        id="checkbox-is_admin"
        class="mt-2"
        v-model="AddFunctionBoxAccountDTO.is_admin"
        name="checkbox-is_admin"
        :value="1"
        switch
        :unchecked-value="0"
      >
        {{ $t("FUNCTIONBOX_ADMIN") }}
      </b-form-checkbox>

      <b-form-checkbox
      id="checkbox-new_message_notification"
      class="mt-2"
      v-model="AddFunctionBoxAccountDTO.new_message_notification"
      name="checkbox-new_message_notification"
      :value="true"
      switch
      :unchecked-value="false"
    >
      {{ $t("FUNCTIONBOX_NOTIFICATIONS") }}
    </b-form-checkbox>

    </b-modal>
  </section>
</template>
<script>
import UserInfo from "@/components/Layout/UserInfo";
export default {
  components: { UserInfo },
  props: ["information"],
  data() {
    return {
      remove_all: false,
      add_all: false,
      addNewUsers: false,
      loading: false,
      show_sidebar: false,
      searchText: "",
      limit: 10,
      currentPage: 1,
      usersPage: 1,
      currentItems: [],
      totalCurrentItems: 0,
      items: [],
      totalItems: 0,
      user_uuids: [],
      fields: [
        {
          key: "id",
          class: "hidden-not-mobile",
          thClass: "",
        },
        {
          key: "name",
          label: this.$t("NAME"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
        {
          key: "email",
          label: this.$t("EMAIL"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
        {
          key: "new_message_notification",
          label: this.$t("NOTIFICATIONS.TITLE"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
        {
          key: "is_admin",
          label: this.$t("ADMINLEVEL.TITLE"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
      ],
      fields_add: [
        {
          key: "id",
          class: "hidden-not-mobile",
          thClass: "",
        },
        {
          key: "name",
          label: this.$t("NAME"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
        {
          key: "email",
          label: this.$t("EMAIL"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        }
      ],
      AddFunctionBoxAccountDTO: {
        functionbox_uuid: this.information.functionbox.functionbox_uuid,
        user_uuids: [],
        is_admin: 0,
        new_message_notification: false
      },
      RemoveFunctionBoxAccountDTO: {
        functionbox_uuid: this.information.functionbox.functionbox_uuid,
        user_uuids: [],
      },
      functionBoxUserSettings: false
    };
  },
  methods: {
    disableCheck(item)
    {
      if (!this.addNewUsers) {
        if(item.is_admin == 1 && this.user.information.is_admin == 0)
        {
          return true;
        }
        return false;
      }
      return true;
    },
    addBtn(){
      if(this.user.information.is_admin > 0)
      {
        this.functionBoxUserSettings = true;
      }else{
        this.okSave();
      }
    },
    clickedRow(item) {
      if (this.addNewUsers) {
        if (this.AddFunctionBoxAccountDTO.user_uuids.includes(item.user_uuid)) {
          let indexOf = this.AddFunctionBoxAccountDTO.user_uuids.indexOf(
            item.user_uuid
          );
          this.AddFunctionBoxAccountDTO.user_uuids.splice(indexOf, 1);
        } else {
          this.AddFunctionBoxAccountDTO.user_uuids.push(item.user_uuid);
        }
      } else {
        if (
          this.RemoveFunctionBoxAccountDTO.user_uuids.includes(item.user_uuid)
        ) {
          let indexOf = this.RemoveFunctionBoxAccountDTO.user_uuids.indexOf(
            item.user_uuid
          );
          this.RemoveFunctionBoxAccountDTO.user_uuids.splice(indexOf, 1);
        } else {
          this.RemoveFunctionBoxAccountDTO.user_uuids.push(item.user_uuid);
        }
      }
    },
    removeAll: function () {
      if (this.remove_all) {
        this.RemoveFunctionBoxAccountDTO.user_uuids = this.currentItems.map(
          (a) => a.user_uuid
        );
      } else {
        this.RemoveFunctionBoxAccountDTO.user_uuids = [];
      }
    },
    addAll: function () {
      if (this.add_all) {
        this.AddFunctionBoxAccountDTO.user_uuids = this.items.map(
          (a) => a.user_uuid
        );
      } else {
        this.AddFunctionBoxAccountDTO.user_uuids = [];
      }
    },
    cancelAdd: function () {
      this.remove_all = false;
      this.getUsers();
      this.addNewUsers = false;
      this.getCurrentUsers();
    },
    showAddBtn: function () {
      this.add_all = false;
      this.getCurrentUsers();
      this.addNewUsers = true;
      this.getUsers();
    },
    getCurrentUsers: function () {
      this.loading = true;
      let self = this;
      this.$http
        .post(this.user.hostname + "/administration/functionbox/users", {
          page: this.currentPage,
          functionbox_uuid: this.information.functionbox.functionbox_uuid,
          state: 1,
          limit: parseInt(this.limit),
          search_text: this.searchText,
        })
        .then((response) => {
          self.loading = false;
          self.currentItems = response.data.items;
          self.totalCurrentItems = response.data.count;
        })
        .catch(() => {
          self.loading = false;
        });
    },
    getUsers: function () {
      this.loading = true;
      let self = this;
      this.$http
        .post(this.user.hostname + "/administration/functionbox/free-users", {
          page: this.usersPage,
          functionbox_uuid: this.information.functionbox.functionbox_uuid,
          state: 1,
          limit: parseInt(this.limit),
          search_text: this.searchText,
        })
        .then((response) => {
          self.loading = false;
          self.items = response.data.items;
          self.totalItems = response.data.count;
        })
        .catch(() => {
          self.loading = false;
        });
    },
    showAdmin: function (is_admin) {
      if(is_admin)
      {
        return this.$t("YES");  
      }
      return "-";
    },
    async okSave() {
      this.loading = true;
      let self = this;
      this.$http
        .post(
          this.user.hostname + "/administration/functionbox/add-account",
          this.AddFunctionBoxAccountDTO
        )
        .then(() => {
          self.getCurrentUsers();
          self.getUsers();
          self.AddFunctionBoxAccountDTO.user_uuids = [];
          self.addNewUsers = false;
          self.loading = false;
          self.showAdd = false;
        })
        .catch(() => {
          self.loading = false;
        });
    },
    cancelSave() {
      this.AddFunctionBoxAccountDTO.is_admin = 0;
    },
    removeBtn: function () {
      let self = this;
      this.$bvModal
        .msgBoxConfirm(this.$t("ARE_YOU_SURE"), {
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("YES"),
          cancelTitle: this.$t("NO"),
          bodyClass: "messagebox",
          footerClass: "p-2  text-center messagebox",
          hideHeaderClose: false,
          centered: true,
        })
        .then(function (value) {
          if (value) {
            self.loading = true;
            self.$http
              .post(
                self.user.hostname + "/administration/functionbox/remove-account",
                self.RemoveFunctionBoxAccountDTO
              )
              .then(() => {
                self.getCurrentUsers();
                self.getUsers();
                self.RemoveFunctionBoxAccountDTO.user_uuids = [];
                self.loading = false;
                self.showAdd = false;
              })
              .catch(() => {
                self.loading = false;
              });
          }
        })
        .catch(function () {});
    },
  },
  computed: {
    valid: function () {
      return this.AddFunctionBoxAccountDTO.user_uuids.length != 0;
    },
    validRemove: function () {
      return this.RemoveFunctionBoxAccountDTO.user_uuids.length != 0;
    },
  },
  watch: {
    searchText: function () {
      if (this.searchText.length == 0) {
        this.getUsers();
        this.getCurrentUsers();
      }
      if (this.searchText.length >= 2) {
        this.getUsers();
        this.getCurrentUsers();
      }
    },
    limit: function () {
      this.getUsers();
      this.getCurrentUsers();
    },
  },
  mounted() {
    this.getCurrentUsers();
  },
};
</script>
<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
